import { render } from "./ExpertButton.vue?vue&type=template&id=dffa88ac&scoped=true"
import script from "./ExpertButton.vue?vue&type=script&lang=js"
export * from "./ExpertButton.vue?vue&type=script&lang=js"

import "./ExpertButton.vue?vue&type=style&index=0&id=dffa88ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dffa88ac"]])

export default __exports__